import React from 'react';
import "./AIMLSytmDevelopmentTools.css"
import { Container, Image, Row } from 'react-bootstrap';
import image1 from "../../../../../assets/ServicePage/chroma.png"
import image2 from "../../../../../assets/ServicePage/AWSSagemaker.png"
import image3 from "../../../../../assets/ServicePage/OpenCV.png"
import image4 from "../../../../../assets/ServicePage/Keras.png"
import image5 from "../../../../../assets/ServicePage/Pytorch.png"
import image6 from "../../../../../assets/ServicePage/Matplotlib.png"
import image7 from "../../../../../assets/ServicePage/Pinecone.png"
import image8 from "../../../../../assets/ServicePage/Langchain.png"



function AIMLSytmDevelopmentTools(props) {
    return (
        <Container className='AIMLSytmDevelopmentTools-container'>
            <Row className='AIMLSytmDevelopmentTools-Row'>
                <div className='AIMLSytmDevelopmentTools-image'>
                    <Image src={image1} alt='visheshcreative.png' style={{ maxWidth: '90%', height: 'auto' }} />
                    <div className='TableData-Text' style={{ color: "var(--text-icon-light-body, #33353A)" }}>Chroma </div>
                </div>
                <div className='AIMLSytmDevelopmentTools-image'>
                    <Image src={image2} alt="visheshcreative.png" style={{ maxWidth: '90%', height: 'auto' }} />
                    <div className='TableData-Text' style={{ color: "var(--text-icon-light-body, #33353A)" }}> AWS SageMaker</div>
                </div>
                <div className='AIMLSytmDevelopmentTools-image'>
                    <Image src={image3} alt="visheshcreative.png" style={{ maxWidth: '90%', height: 'auto' }} />
                    <div className='TableData-Text' style={{ color: "var(--text-icon-light-body, #33353A)" }}> OpenCV</div>
                </div>
                <div className='AIMLSytmDevelopmentTools-image'>
                    <Image src={image4} alt="visheshcreative.png" style={{ maxWidth: '90%', height: 'auto' }} />
                    <div className='TableData-Text' style={{ color: "var(--text-icon-light-body, #33353A)" }}> Keras</div>
                </div>
                <div className='AIMLSytmDevelopmentTools-image'>
                    <Image src={image5} alt="visheshcreative.png" style={{ maxWidth: '90%', height: 'auto' }} />
                    <div className='TableData-Text' style={{ color: "var(--text-icon-light-body, #33353A)" }}> PyTorch</div>
                </div>
                <div className='AIMLSytmDevelopmentTools-image'>
                    <Image src={image6} alt="visheshcreative.png" style={{ maxWidth: '90%', height: 'auto' }} />
                    <div className='TableData-Text' style={{ color: "var(--text-icon-light-body, #33353A)" }}> Matplotlib</div>
                </div>
                <div className='AIMLSytmDevelopmentTools-image'>
                    <Image src={image7} alt="visheshcreative.png" style={{ maxWidth: '90%', height: 'auto' }} />
                    <div className='TableData-Text' style={{ color: "var(--text-icon-light-body, #33353A)" }}> Pinecone</div>
                </div>
                <div className='AIMLSytmDevelopmentTools-image'>
                    <Image src={image8} alt="visheshcreative.png" style={{ maxWidth: '90%', height: 'auto' }} />
                    <div className='TableData-Text' style={{ color: "var(--text-icon-light-body, #33353A)" }}> LangChain</div>
                </div>

            </Row>
        </Container>
    );
}

export default AIMLSytmDevelopmentTools;